import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

const SubmitDropoffSuccess: React.FC = () => {
    const intl = useIntl()
    return (
        <SubmitDropoffSuccessContainer>
            {intl.formatMessage({id: 'SubmitDropoff.success.message'})}
        </SubmitDropoffSuccessContainer>
    )
}

const SubmitDropoffSuccessContainer = styled.div`
    width: 100%;
    text-align: left;
    font-style: normal;
    font-weight: ${({ theme }) => theme.weight.light};
    font-size: ${({ theme }) => theme.size.small};
    color: ${({ theme }) => theme.color.black};
    font-family: ${({ theme }) => theme.font.default};
    padding-bottom: 14px;
    padding-top: 14px;
`

export default SubmitDropoffSuccess
